import { injectIntl } from "react-intl";
import Column from "../Grid/Column";
import Row from "../Grid/Row";

type OwnProps = {
  message?: string | React.ReactElement;
};

const defaultProps: Partial<OwnProps> = {};

type Props = OwnProps & typeof defaultProps;

export function SubClue({ message }: Props) {
  return (
    <div>
      <Row>
        <Column>
          <div id="sub-clue-box" className="clue-box">
            <div>
              <h5>
                <span className="clue-box-icon icon2-eh-notification ninja-icon" />
              </h5>
            </div>
            <div className="clue-box-content">
              <h5 id="clue-content" className="clue-box-content">
                {message}
              </h5>
            </div>
          </div>
        </Column>
      </Row>
    </div>
  );
}

SubClue.defaultProps = defaultProps;

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(SubClue);
